import React from 'react'
import { Grid, Cell } from 'react-blazecss/lib/Grid'

import { nameOf, sortNameOf,  } from './utils'
import { removeDiacritics } from '../utils/strings'

// import 'blaze/dist/blaze.min.css'
import 'blaze/dist/objects.grid.min.css'
import 'blaze/dist/objects.grid.responsive.min.css'
// <li id="eg-103-post-id-1989" class="filterall filter-comedienne eg-jason-wrapper eg-post-id-1989 tp-esg-item itemtoshow isvisiblenow" data-date="1471445266" style="opacity: 1; visibility: inherit; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0.1, 0.999917); height: auto; width: 364px; display: block; top: 0px; left: 404px; transform-origin: center center 0px;">
//     <div class="esg-media-cover-wrapper">
// <a href="http://cyrillejoubert-talents.com/ninapropal3/" target="_self"><div class="esg-entry-media-wrapper" style="overflow:hidden;position:relative;"><div class="esg-entry-media" style="padding-bottom: 100%;"><img src="http://cyrillejoubert-talents.com/wp-content/plugins/essential-grid/public/assets/images/300x200transparent.png" data-lazythumb="http://cyrillejoubert-talents.com/wp-content/uploads/2016/07/Nina_1-300x300-25x25.png" data-lazysrc="http://cyrillejoubert-talents.com/wp-content/uploads/2016/07/Nina_1-300x300.png" alt="Nina-Lopata-Cyrille-Joubert-1" width="300" height="300" style="display: none;"><div class="esg-media-poster coverremoved" src="http://cyrillejoubert-talents.com/wp-content/uploads/2016/07/Nina_1-300x300.png" data-src="http://cyrillejoubert-talents.com/wp-content/uploads/2016/07/Nina_1-300x300.png" data-lazythumb="http://cyrillejoubert-talents.com/wp-content/uploads/2016/07/Nina_1-300x300-25x25.png" style="background-image: url(&quot;http://cyrillejoubert-talents.com/wp-content/uploads/2016/07/Nina_1-300x300.png&quot;); z-index: 1; visibility: inherit; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);"></div></div></div>

// </a>                <div class="esg-overlay esg-flipup eg-jason-container" data-delay="0" style="visibility: hidden; opacity: 0; transform-origin: 50% 100% 0px; transform-style: flat; transform: matrix3d(0.8, 0, 0, 0, 0, 0, 0.8, -0.000666667, 0, -1, 0, 0, 0, 0, 0.001, 0.999999);"></div>

// <div class="esg-entry-content eg-jason-content esg-notalone" style="min-height: 0px;">
// 				<div class="esg-content eg-post-1989 eg-jason-element-0-a"><a class="eg-jason-element-0 eg-post-1989" href="http://cyrillejoubert-talents.com/ninapropal3/" target="_self">NinaPropal3</a></div>
// </div>   </div>

// </li>

const host = REST_API// "http://localhost:8080"
// const baseUrl = "http://images.cyrillejoubert-talents.com/api/files"
const baseUrl = host + "/api/files"


const ProfileCell = (props) => {
  const imgUrl = props.profileImage ? (baseUrl + "/" + props.profileImage.id + "/thumbnail?w=240&h=280&auto") : null
  const cleanName = removeDiacritics(nameOf(props).toLowerCase()).replace(/[^a-z0-9]/g, '-')
  const url = props.baseUrl + '/' + props.id + '/' + cleanName + '/'
  return (
    <Cell lg="25" md="33" width="50" style={{padding: 8}}>
      <a className="gl-card" href={url}>
        <div style={{overflow: 'hidden', position: 'relative'}}>
          <img className="gl-card__image" style={{width: '100%'}} src={imgUrl}/>
          <div className="gl-card__overlay" />
        </div>
        <div className="gl-card__title" >{nameOf(props)}</div>
      </a>
    </Cell>
  )
}

function sortProfiles(profiles){
  const newProfiles = [...profiles]
  profiles.sort((a, b) => {
    if (sortNameOf(a) < sortNameOf(b)) return -1
    else return 1
  })
  return profiles
}

function filterProfiles(profiles, text){
  if (!text || text.length == 0) return profiles

  text = text.toLowerCase()

  return profiles.filter(p => {
    const pseudoFirstName = p.pseudoFirstName || ""
    const pseudoLastName= p.pseudoLastName || ""
    return pseudoFirstName.toLowerCase().startsWith(text) || pseudoLastName.toLowerCase().startsWith(text);
  })
}

export class ProfileGrid extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      filter: ''
    }

    this.onChange = (e) => {
      this.setState({
        filter: e.target.value
      })
    }
  }

  render(){
    const { profiles, /*hasFilter=true*/ } = this.props
    const hasFilter = false
    const finalProfiles = sortProfiles(filterProfiles(profiles, this.state.filter))
    return (
      <div>
        {hasFilter ? (
          <div>
            Filtrer : 
            <input style={{width: 200, marginLeft: 16, padding: 8}} type="text" onChange={this.onChange} value={this.state.filter} />
          </div>
        ) : null}
        <Grid>
          {finalProfiles.map((profile, idx) => <ProfileCell key={idx} {...profile} />)}
        </Grid>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/profile/grid.js
 **/